import * as React from 'react';
import { Accordion, Switcher, Text } from '@shared/ui-components';

import { SubscriptionAddon } from '../../../interfaces/subscription-addon';
import { SubscriptionPlanVariant } from '../../../interfaces/subscription-plan-variant';
import { Styled } from './styled';

interface AddonsGroup {
  title: string;
  content: JSX.Element;
}

interface Props {
  selectedAddonGroups: string[];
  addons: SubscriptionAddon[];
  subscriptionPlans: SubscriptionPlanVariant[];
  onSelectedAddonGroupsChange: (selectedAddonGroups: string[]) => void;
}

export class SubscriptionAddons extends React.Component<Props> {
  public render(): React.ReactNode {
    const addons = this.getAddons();
    if (!addons) {
      return null;
    }

    return (<Accordion content={addons} isBlocksOpen={true} />);
  }

  private getAddons(): AddonsGroup[] {
    const addons = this.props.addons.filter(addon => addon.isSelfService);
    if (!addons.length) {
      return null;
    }
    return [{
      title: 'Add-ons',
      content: (
        <Styled.Container>
          {addons.map(x => this.renderAddon(x))}
        </Styled.Container>
      ),
    }];
  }

  private renderAddon(addon: SubscriptionAddon): JSX.Element {
    const { selectedAddonGroups, subscriptionPlans } = this.props;
    const onToggle = (): void => this.onToggleSelection(addon.groupName);

    return (
      <Styled.Row key={addon.id} planLength={subscriptionPlans.length}>
        <Styled.FeatureHead>
          <Switcher
            checked={selectedAddonGroups.includes(addon.groupName)}
            onChange={onToggle} // eslint-disable-line react/jsx-no-bind
            size='s'
          />
          <Text fontSize={16} color='mainFont'>{addon.groupName}</Text>
        </Styled.FeatureHead>
        {
          subscriptionPlans.map((x, index) => (
            <Styled.FeatureValue key={index}>
              <Text fontSize={16} color='mainFont'>
                {x.availableAddons.includes(addon.id) ? 'Yes' : 'No'}
              </Text>
            </Styled.FeatureValue>
          ))
        }
      </Styled.Row>
    );
  }

  private onToggleSelection(groupName: string): void {
    const selectedAddonGroups = this.props.selectedAddonGroups.includes(groupName)
      ? this.props.selectedAddonGroups.filter(x => x !== groupName)
      : this.props.selectedAddonGroups.concat(groupName);

    this.props.onSelectedAddonGroupsChange(selectedAddonGroups);
  }
}
